// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
// jQuery(function ($) {
//   // var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
//   var headerHeight = $("header").innerHeight(); // ヘッダー追従の場合 // if header following
//   $('a[href^="#"]').click(function () {
//     var href = $(this).attr("href");
//     var target = $(href == "#" || href == "" ? "html" : href);
//     if (target.length > 0) {
//       var position = target.offset().top - headerHeight;
//       $("html, body").animate({ scrollTop: position }, 550, "swing");
//       return false;
//     }
//   });
// });
jQuery(window).on("load", function () {
  let $ = jQuery;
  // ページのURLを取得
  const url = $(location).attr("href");
  const headerHeight = $("header").innerHeight();

  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    if (target.length > 0) {
      var position = target.offset().top - headerHeight;
      $("html, body").animate({ scrollTop: position }, 550, "swing");
      return false;
    }
  });
});
jQuery(function ($) {
  //遷移ページURLのハッシュ部分を取得します
  const hash = location.hash;
  const headerHeight = $("header").innerHeight();
  // ハッシュがある場合の条件分岐を促します
  if (hash) {
    //ページ遷移後のスクロール位置指定
    $("html, body").stop().scrollTop(0);
    setTimeout(function () {
      //アンカーリンク先を取得
      const target = $(hash);
      if (target.length > 0) {
        var position = target.offset().top - headerHeight;
        $("html, body").animate({ scrollTop: position }, 500, "swing");
        return false;
      }
    });
  }
});
function getUrlVars() {
  var vars = [],
    hash,
    hashes = window.location.href.slice(window.location.href.indexOf("?") + 1).split("&");
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split("=");
    if (hash.length > 1) {
      var _var = hash[1].replace(/#.+/, "");
      if (_var != "") {
        vars[hash[0]] = _var;
      } else {
        vars[hash[0]] = "Null";
      }
    }
  }
  return vars;
}

// ブログサムネイル 中心でトリミング // Blog thumbnail Crop at center
jQuery(function ($) {
  if ($(".obj_image").length > 0) {
    objectFitImages(".obj_image");
  }
});

// ヘッダーの固定エフェクト; // Fixed header effect
jQuery(function ($) {
  var $header = $("header");
  $(window).scroll(function () {
    if ($(window).scrollTop() > 50) {
      $header.addClass("fixed");
    } else {
      $header.removeClass("fixed");
    }
  });
});

// アコーディオンの起動 // Activate the accordion
jQuery(function ($) {
  if ($(".js-accordion").length > 0) {
    $(".js-accordion .js-accordion-head").click(function () {
      $(this).next(".js-accordion-inner").slideToggle();
      //   $(this).toggleClass("open");
    });
  }
});

// ドロワーメニュー // Drawer menu
jQuery(function ($) {
  if ($("#toggle").length > 0) {
    $("#toggle").click(function () {
      $(this).toggleClass("toggle_active");
      $("#drawer_layer").fadeToggle();
      $("body").toggleClass("drawer_open");

      if ($(this).hasClass("toggle_active")) {
        $("nav").addClass("is_open");
        $("nav").removeClass("is_close");
      } else {
        $("nav").removeClass("is_open");
        $("nav").addClass("is_close");
      }
    });

    $("#drawer_layer").click(function () {
      $(this).fadeOut();
      $("#toggle").removeClass("toggle_active");
      $("body").removeClass("drawer_open");
      $("nav").removeClass("is_open");
      $("nav").addClass("is_close");
    });
  }
});

jQuery(function ($) {
  var width = $(window).width();
  if (width <= 1150) {
    $(".l-header-nav__item--parent>p").off("click");
    $(".l-header-nav__item--parent>p").click(function () {
      // var parentElem = $(this).parent();
      // $(parentElem).toggleClass("active");
      $(".l-header-nav__sub").slideToggle();
      return false;
    });
  }
});

//追従バナー
jQuery(function ($) {
  if ($(".c-fixCV").length > 0) {
    var btnCV = $(".c-fixCV");
    var winW = $(window).width();
    if (winW > 769) {
      var scrollEnd = $(".p-topColumn").outerHeight() / 2 + $(".p-topColumn").offset().top;
    } else if (winW <= 768) {
      var scrollEnd = $(".p-topColumn").outerHeight() / 2 + 100 + $(".p-topColumn").offset().top;
    }
    btnCV.css("display", "none");
    //スクロールが100に達したらボタン表示 // display button when scroll reaches 100
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100 && $(this).scrollTop() < scrollEnd) {
        btnCV.fadeIn();
      } else {
        btnCV.fadeOut();
      }
    });
  }
});

jQuery(function ($) {
  var width = $(window).width();
  if (width <= 767) {
    $(".js-toggle").click(function () {
      $(this).toggleClass("active");
      $(".l-footer__service").slideToggle();
    });
  }
});

// FAQ検索
// const search = document.getElementById("search");
// if (search) {
//   search.onsubmit = function (event) {
//     event.preventDefault();
//     const keyword = document.getElementById("search").keyword.value.trim().toLowerCase();
//     const searchTargets = document.querySelectorAll(".p-faq__txt");
//     searchTargets.forEach((target) => {
//       const text = target.textContent.toLowerCase();
//       targetWrap = target.closest(".p-faq__wrap");
//       if (text.includes(keyword)) {
//         targetWrap.style.display = "block";
//       } else {
//         targetWrap.style.display = "none";
//       }
//     });

//     const faqCont = document.getElementsByClassName("p-faq__content")[0];
//     faqCont.classList.add("result");

//     const visibleTargets = Array.from(searchTargets).filter((target) => target.closest(".p-faq__wrap").style.display === "block");
//     const message = document.getElementsByClassName("p-faq__msg")[0];
//     if (visibleTargets.length === 0) {
//       if (!message) {
//         faqCont.insertAdjacentHTML("afterbegin", '<p class="p-faq__msg">検索結果がありません。</p>');
//       }
//     } else {
//       message.style.display = "none";
//     }
//   };
// }

// ページトップボタンの表示 // Display the page top button
jQuery(function ($) {
  if ($("#pageup").length > 0) {
    var topBtn = $("#pageup");
    topBtn.css("display", "none");
    //スクロールが100に達したらボタン表示 // display button when scroll reaches 100
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        topBtn.fadeIn();
      } else {
        topBtn.fadeOut();
      }
    });
    //スクロールしてトップ // scroll to the top
    topBtn.click(function () {
      $("body,html").animate(
        {
          scrollTop: 0,
        },
        500
      );
      return false;
    });
  }
});
